import { css, unsafeCSS } from 'lit';
import color from '../utils/get-color-token';

function skeletonStyles() {
	return css`
		@keyframes skeleton-loading {
			0% {
				background-color: ${color('color-background-tertiary')};
				opacity: 0.3;
			}
			50% {
				background-color: ${color('color-background-tertiary')};
				opacity: 0.6;
			}
			100% {
				background-color: ${color('color-background-tertiary')};
			}
		}
	`;
}

export function skeleton() {
	return unsafeCSS(`animation: skeleton-loading 1s linear infinite alternate;`);
}

export default skeletonStyles;
